(function () {
  if (window.nnProductCardInit) return;
  window.nnProductCardInit = true;

  /* ---------------- Helpers ---------------- */
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------- Modal helpers ---------------- */
  function moveModalsToBodyOnce() {
    var modals = document.querySelectorAll('.nn-options-modal');
    modals.forEach(function (modal) {
      if (!modal.dataset.nnMovedToBody) {
        document.body.appendChild(modal);
        modal.dataset.nnMovedToBody = 'true';
      }
    });
  }

  function openModal(productId) {
    var modal = document.querySelector(
      '.nn-options-modal[data-nn-options-modal="' + productId + '"]'
    );
    if (!modal) return;

    modal.hidden = false;
    document.documentElement.classList.add('nn-options-open');
    if (document.body) document.body.classList.add('nn-options-open');
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.hidden = true;

    if (!document.querySelector('.nn-options-modal:not([hidden])')) {
      document.documentElement.classList.remove('nn-options-open');
      if (document.body) document.body.classList.remove('nn-options-open');
    }
  }

  /* ---------------- Cart notification hook ---------------- */
  function getCartNotificationEl() {
    return document.querySelector('cart-notification');
  }

  /* ---------------- Free shipping progress ---------------- */
  function getThresholdCents() {
    var progressBar = document.getElementById('cart-progress');
    if (!progressBar) return 3000;
    var t = parseInt(progressBar.dataset.threshold, 10);
    return isNaN(t) ? 3000 : t;
  }

  function updateProgressBar(cart, animate) {
    var progressBar = document.getElementById('cart-progress');
    var progressFill = document.getElementById('cart-progress-fill');
    var progressText = document.getElementById('cart-progress-text');
    if (!progressBar || !progressFill || !progressText) return;

    var threshold = getThresholdCents();
    var subtotal = cart && cart.total_price != null ? parseInt(cart.total_price, 10) || 0 : 0;

    var percentage = 0;
    if (subtotal <= 0) {
      percentage = 0;
    } else if (subtotal >= threshold) {
      percentage = 100;
    } else {
      percentage = (subtotal / threshold) * 100;
    }

    progressFill.style.setProperty('width', percentage + '%', 'important');

    if (subtotal >= threshold) {
      progressText.textContent =
        "You’ve unlocked free shipping and auto discounts – crunch on!";
      progressBar.classList.add('catalog-progress--achieved');
    } else if (subtotal > 0) {
      var remaining = threshold - subtotal;
      progressText.textContent =
        "Only " + formatMoney(remaining) + " more for free shipping!";
      progressBar.classList.remove('catalog-progress--achieved');
    } else {
      progressText.textContent =
        "Shipping costs $3.80, or FREE with another $30!";
      progressBar.classList.remove('catalog-progress--achieved');
    }

    if (animate) {
      progressBar.classList.add('catalog-progress--pulse');
      setTimeout(function () {
        progressBar.classList.remove('catalog-progress--pulse');
      }, 600);
    }
  }

  function fetchAndUpdateProgressBar(animate) {
    var progressBar = document.getElementById('cart-progress');
    if (!progressBar) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateProgressBar(cart, animate); })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var els = document.querySelectorAll('.cart-count');
        els.forEach(function (el) { el.textContent = cart.item_count; });
        fetchAndUpdateProgressBar(false);
      })
      .catch(function () {});
  }

  /* ---------------- Core add to cart ---------------- */
  async function addToCart(variantId, quantity) {
    var cartNotificationElement = getCartNotificationEl();
    var hasCartNotification =
      cartNotificationElement &&
      typeof cartNotificationElement.getSectionsToRender === 'function';

    var bodyData = { id: variantId, quantity: quantity };

    if (hasCartNotification) {
      bodyData.sections = cartNotificationElement
        .getSectionsToRender()
        .map(function (section) { return section.id; });
      bodyData.sections_url = window.location.pathname;

      if (typeof cartNotificationElement.setActiveElement === 'function') {
        cartNotificationElement.setActiveElement(
          document.activeElement || cartNotificationElement
        );
      }
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) return false;

    var parsedState = await response.json();

    if (
      hasCartNotification &&
      parsedState &&
      !parsedState.status &&
      typeof cartNotificationElement.renderContents === 'function'
    ) {
      cartNotificationElement.renderContents(parsedState);
    }

    updateCartCount();
    fetchAndUpdateProgressBar(true);

    return true;
  }

  /* ---------------- Wishlist pin init ---------------- */
  function initializePinnedProducts() {
    try {
      var pinned = JSON.parse(localStorage.getItem('pinnedProducts') || '[]');
      pinned.forEach(function (handle) {
        var card = document.querySelector('[data-product-handle="' + handle + '"]');
        if (!card) return;
        var btn = card.querySelector('.product-card__wishlist');
        if (btn) btn.classList.add('active', 'pinned');
      });
    } catch (e) {}
  }

  /* ---------------- Initial one-time setup ---------------- */
  ready(function () {
    // Move modals created by snippets into body
    moveModalsToBodyOnce();

    // Initial shipping bar
    fetchAndUpdateProgressBar(false);

    // Restore pinned hearts
    initializePinnedProducts();

    // Sort select (unchanged logic)
    var sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    // View toggle (unchanged logic)
    var viewButtons = document.querySelectorAll('.catalog-view__btn');
    var productGrids = document.querySelectorAll('.catalog-products');
    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var view = this.dataset.view;
        viewButtons.forEach(function (btn) { btn.classList.remove('active'); });
        this.classList.add('active');
        productGrids.forEach(function (grid) {
          grid.className = 'catalog-products catalog-products--' + view;
        });
      });
    });
  });

  /* ---------------- Single delegated click handler ---------------- */
  document.addEventListener('click', async function (e) {
    /* 1) Open variant modal */
    var openBtn = e.target.closest('[data-nn-open-options]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.getAttribute('data-nn-open-options'));
      return;
    }

    /* 2) Close modal on backdrop/outside dialog */
    var modalContainer = e.target.closest('.nn-options-modal');
    var insideDialog = e.target.closest('.nn-options-modal__dialog');
    if (modalContainer && !insideDialog) {
      closeModal(modalContainer);
      return;
    }

    /* 3) Wishlist pin */
    var wishlistBtn = e.target.closest('.product-card__wishlist');
    if (wishlistBtn) {
      e.preventDefault();
      e.stopPropagation();

      var productCard = wishlistBtn.closest('.product-card');
      if (!productCard) return;

      var handle = productCard.dataset.productHandle;
      wishlistBtn.classList.toggle('active');
      wishlistBtn.classList.toggle('pinned');

      try {
        var pinned = JSON.parse(localStorage.getItem('pinnedProducts') || '[]');
        var idx = pinned.indexOf(handle);

        if (idx > -1) {
          pinned.splice(idx, 1);
          wishlistBtn.style.color = '';
        } else {
          pinned.push(handle);
          wishlistBtn.style.color = '#ef4444';
        }

        localStorage.setItem('pinnedProducts', JSON.stringify(pinned));
      } catch (err) {}

      return;
    }

    /* 4) Quick add */
    var quickBtn = e.target.closest('.quick-add-btn');
    if (quickBtn) {
      var variantId = quickBtn.dataset.variantId;
      if (!variantId) return;

      var originalText = quickBtn.textContent;

      try {
        quickBtn.textContent = 'Adding...';
        quickBtn.disabled = true;

        var success = await addToCart(variantId, 1);

        if (success) {
          quickBtn.textContent = 'Add more';
          quickBtn.disabled = false;

          quickBtn.classList.add('btn--pulse');
          setTimeout(function () {
            quickBtn.classList.remove('btn--pulse');
          }, 350);

          // If this was inside modal & requires closing
          if (quickBtn.hasAttribute('data-nn-close-after-add')) {
            var modal2 = quickBtn.closest('.nn-options-modal');
            if (modal2) {
              setTimeout(function () { closeModal(modal2); }, 150);
            }
          }
        } else {
          quickBtn.textContent = 'Error';
          setTimeout(function () {
            quickBtn.textContent = originalText;
            quickBtn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        quickBtn.textContent = 'Error';
        setTimeout(function () {
          quickBtn.textContent = originalText;
          quickBtn.disabled = false;
        }, 2000);
      }

      return;
    }

    /* 5) Card click-to-PDP (handle-based) */
    var card = e.target.closest('.product-card[data-product-handle]');
    if (!card) return;

    // Don't hijack real interactive clicks
    if (e.target.closest('a, button, input, select, textarea, label, [role="button"], .nn-options-modal')) {
      return;
    }

    var handle2 = card.getAttribute('data-product-handle');
    if (handle2) {
      window.location.href = '/products/' + handle2;
    }
  });

  /* ---------------- ESC closes any open modal ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModalEl = document.querySelector('.nn-options-modal:not([hidden])');
    if (openModalEl) closeModal(openModalEl);
  });

})();
